import { render, staticRenderFns } from "./RecommendationCard.vue?vue&type=template&id=75e2e69e&scoped=true&"
import script from "./RecommendationCard.vue?vue&type=script&lang=ts&"
export * from "./RecommendationCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecommendationCard.vue?vue&type=style&index=0&id=75e2e69e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e2e69e",
  null
  
)

export default component.exports